"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FetchTranslationsWithNamespacesOptions = require("./FetchTranslationsWithNamespacesOptions");
Object.keys(_FetchTranslationsWithNamespacesOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FetchTranslationsWithNamespacesOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FetchTranslationsWithNamespacesOptions[key];
    }
  });
});
var _Language = require("./Language");
Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Language[key];
    }
  });
});
var _Translations = require("./Translations");
Object.keys(_Translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Translations[key];
    }
  });
});
var _TranslationsWithNamespaces = require("./TranslationsWithNamespaces");
Object.keys(_TranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationsWithNamespaces[key];
    }
  });
});
var _ValuesArgForMessage = require("./ValuesArgForMessage");
Object.keys(_ValuesArgForMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ValuesArgForMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ValuesArgForMessage[key];
    }
  });
});
var _InferPlaceholders = require("./InferPlaceholders");
Object.keys(_InferPlaceholders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InferPlaceholders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InferPlaceholders[key];
    }
  });
});
var _StrictMessageValues = require("./StrictMessageValues");
Object.keys(_StrictMessageValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StrictMessageValues[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StrictMessageValues[key];
    }
  });
});
var _InferHtmlTags = require("./InferHtmlTags");
Object.keys(_InferHtmlTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InferHtmlTags[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InferHtmlTags[key];
    }
  });
});
//# sourceMappingURL=index.js.map